var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarHalf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#CDCDCD",
    fillRule: "nonzero",
    d: "M10 16.035L6.137 18.17c-.483.268-1.092.092-1.359-.391-.109-.196-.148-.423-.112-.645l.75-4.6-3.224-3.305c-.385-.395-.377-1.028.018-1.414.15-.146.34-.241.547-.273L4 7.352l3.167-.484 1.928-4.106c.234-.5.83-.715 1.33-.48.211.099.381.269.48.48l1.928 4.106 4.41.674c.546.084.92.594.837 1.14-.031.206-.127.398-.272.547l-3.225 3.305.75 4.6c.09.545-.28 1.06-.825 1.148-.222.036-.449-.003-.645-.112L10 16.035z",
    transform: "translate(-166 -1087) translate(70 1087) translate(96)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE1E",
    d: "M10 2.187v13.848L6.137 18.17c-.483.268-1.092.092-1.359-.391-.109-.196-.148-.423-.112-.645l.75-4.6-3.224-3.305c-.385-.395-.377-1.028.018-1.414.15-.146.34-.241.547-.273L4 7.352l3.167-.484 1.928-4.106c.17-.362.53-.575.905-.575z",
    transform: "translate(-166 -1087) translate(70 1087) translate(96)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarHalf);
export default __webpack_public_path__ + "static/media/star-half.d149f477.svg";
export { ForwardRef as ReactComponent };